export const IS_ASSESSMENT_REVAMP_ENABLED =
  process.env.NEXT_PUBLIC_ASSESSMENT_REVAMP_ENABLED === 'true'

export const IS_IKM_REGISTRATION_LANDING_ENABLED =
  process.env.NEXT_PUBLIC_IKM_REGISTRATION_LANDING_ENABLED === 'true'

export const IS_IKM_REGISTRATION_HOME_ENABLED =
  process.env.NEXT_PUBLIC_IKM_REGISTRATION_HOME_ENABLED === 'true'

export const IS_UJIKOM_ENTRY_HOME_ENABLED =
  process.env.NEXT_PUBLIC_UJIKOM_ENTRY_HOME_ENABLED === 'true'

export const IS_UJIKOM_ENTRY_LANDING_ENABLED =
  process.env.NEXT_PUBLIC_UJIKOM_ENTRY_LANDING_ENABLED === 'true'

export const IS_PROFILE_REVAMP_PHASE_TWO_ENABLED =
  process.env.NEXT_PUBLIC_PROFILE_REVAMP_PHASE_TWO_ENABLED === 'true'

export const IS_PROFILE_REVAMP_PHASE_THREE_ENABLED =
  process.env.NEXT_PUBLIC_PROFILE_REVAMP_PHASE_THREE_ENABLED === 'true'

export const IS_TENTANG_KURIKULUM_MERDEKA_ENTRY_POINT_ENABLED =
  process.env.NEXT_PUBLIC_TENTANG_KURIKULUM_MERDEKA_ENTRY_POINT_ENABLED ===
  'true'

export const IS_HOMEPAGE_BANNERS_ENABLED =
  process.env.NEXT_PUBLIC_HOMEPAGE_BANNERS_ENABLED === 'true'

export const IS_HOME_CONTENT_COLLECTION_V2_ENABLED =
  process.env.NEXT_PUBLIC_HOME_CONTENT_COLLECTION_V2_ENABLED === 'true'

export const IS_REFLEKSI_KOMPETENSI_ENTRY_HOME_ENABLED =
  process.env.NEXT_PUBLIC_REFLEKSI_KOMPETENSI_ENTRY_HOME_ENABLED === 'true'

export const IS_CONTENT_SEARCH_ENABLED =
  process.env.NEXT_PUBLIC_CONTENT_SEARCH_ENABLED === 'true'

export const IS_INSPIRATION_PAGE_ENABLED =
  process.env.NEXT_PUBLIC_INSPIRATION_PAGE_ENABLED === 'true'

export const IS_LMS_PMM_HOMEPAGE_ENTRY_ENABLED =
  process.env.NEXT_PUBLIC_LMS_HOMEPAGE_ENTRYPOINT === 'true'

export const IS_PROFILE_CERTIFICATE_ENABLED =
  process.env.NEXT_PUBLIC_PROFILE_CERTIFICATE_ENABLED === 'true'

export const IS_CONVERSATION_WITH_AI_ENABLED =
  process.env.NEXT_PUBLIC_CONVERSATION_WITH_AI_ENABLED === 'true'

export const IS_DOCUMENT_COLLECTION_ENABLED =
  process.env.NEXT_PUBLIC_DOCUMENT_COLLECTION_ENABLED === 'true'
